"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "brandingSettings", {
  enumerable: true,
  get: function get() {
    return _brandingSettings["default"];
  }
});
var _brandingSettings = _interopRequireDefault(require("./brandingSettings"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }